export default function PrilohaField(server, $window){
  return {
    restrict: "E",
    require: "?ngModel",
    template: require("./PrilohaField.html"),
    link: function(scope, element, attr, ngModelController){

      scope.downloadFile = function(){
        $window.open(server.getRequestUrl("downloadPriloha", {id: ngModelController.$viewValue.id}))
      }

      scope.setDeleted = function(isDeleted){
        var value = ngModelController.$viewValue;
        ngModelController.$setViewValue({id: value.id, nazov: value.nazov, file: value.file, deleted:isDeleted});
      }
      
      ngModelController.$render = function(){
          scope.data = ngModelController.$viewValue;
          scope.showThumbnail = scope.data.file.type.startsWith("image/");
          scope.thumnailUrl = server.getRequestUrl("downloadPriloha", {id: ngModelController.$viewValue.id});
      }
    }    
  }
}


// WEBPACK FOOTER //
// ./src/util/PrilohaField.js